import type { AnalyticsFacade } from '@aurumrun/analytics'

/** Access the shared analytics facade provided by analytics.client.ts. */
export function useAnalytics(): AnalyticsFacade {
  return useNuxtApp().$analytics as AnalyticsFacade
}
